import "@frontend/roz-uikit/styles.css";
import "./styles/index.css";

import { SDK_IDS } from "@frontend/roz-sdk-core";
import { StrictMode } from "react";
import { createRoot, type Root } from "react-dom/client";

import type { LoaderConfig } from "@/loader-config";
import { shellPropsFromConfig } from "@/loader-config";
import { resolveShell } from "@/presets/shellRegistry";
import { type SdkInstance, SdkProvider } from "@/provider";

let root: Root | null = null;

function createContainer(): HTMLElement {
  let container = document.getElementById(SDK_IDS.sdkRoot);
  if (!container) {
    container = document.createElement("div");
    container.id = SDK_IDS.sdkRoot;
    document.body.prepend(container);
  }
  return container;
}

export function mountShell(sdk: SdkInstance, config: LoaderConfig): void {
  const container = createContainer();
  const Shell = resolveShell(config.shell);
  const shellProps = shellPropsFromConfig(config);

  root = createRoot(container);
  root.render(
    <StrictMode>
      <SdkProvider sdk={sdk}>
        <Shell {...shellProps}>{null}</Shell>
      </SdkProvider>
    </StrictMode>
  );
}

export function unmountShell(): void {
  const container = document.getElementById(SDK_IDS.sdkRoot);
  if (root) {
    root.unmount();
    root = null;
  }
  container?.remove();
}
